import React from 'react';

import { getAppText } from 'Utils/text';
import { AppError } from '../AppError';

export function NoMatch(): React.ReactElement {
  return (
    <AppError
      title={getAppText('misc.error.noMatch.title')}
      description={getAppText('misc.error.noMatch.description')}
    />
  );
}
